export function listCompetition(params) {
    return window.axios.post("api/competition/list", params)
}
export function deleteCompetition(id) {
    return window.axios.post("api/competition/delete", {id:id})
}
export function updateCompetition(params) {
    return window.axios.post("api/competition/update", params)
}

export function updateAuditStatus(params) {
    return window.axios.post("api/competition/updateAuditStatus", params)
}


export function addCompetition(params) {
    return window.axios.post("api/competition/add", params)
}
export function getCompetition(id) {
    return window.axios.post("api/competition/get", {id: id})
}
export function exportCompetition(params) {
    let config = {
        responseType: "blob"
    }
    return window.axios.post("api/competition/export/excel", params, config)
}
